import { createSlice } from "@reduxjs/toolkit";

const selectedSetSlice = createSlice({
  name: "selectedSet",
  initialState: "-1",
  reducers: {
    setSelectedSet: (_state, action) => action.payload,
  },
});

const selectionListSlice = createSlice({
  name: "selectionList",
  initialState: [],
  reducers: {
    setSelectionList: (_state, action) => action.payload,
  },
});

const selectionListIdObjSlice = createSlice({
  name: "selectionListIdObj",
  initialState: {},
  reducers: {
    setSelectionListIdObj: (_state, action) => action.payload,
  },
});

const selectedSelectionSetItemsListSlice = createSlice({
  name: "selectedSelectionSetItemsList",
  initialState: [],
  reducers: {
    setSelectedSelectionSetItemsList: (_state, action) => action.payload,
  },
});

const selectionSetUpdatedSlice = createSlice({
  name: "selectionSetUpdated",
  initialState: false,
  reducers: {
    setSelectionSetUpdated: (_state, action) => action.payload,
  },
});

export const { setSelectedSet } = selectedSetSlice.actions;
export const { setSelectionList } = selectionListSlice.actions;
export const { setSelectionListIdObj } = selectionListIdObjSlice.actions;
export const { setSelectedSelectionSetItemsList } = selectedSelectionSetItemsListSlice.actions;
export const { setSelectionSetUpdated } = selectionSetUpdatedSlice.actions;

export const selectedSet = selectedSetSlice.reducer;
export const selectionList = selectionListSlice.reducer;
export const selectionListIdObj = selectionListIdObjSlice.reducer;
export const selectedSelectionSetItemsList = selectedSelectionSetItemsListSlice.reducer;
export const selectionSetUpdated = selectionSetUpdatedSlice.reducer;
